// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Array from "../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as RouterProvider$Showside from "./RouterProvider.bs.js";
import * as ConfigurationProvider$Showside from "./ConfigurationProvider.bs.js";
import * as UseCategoryDisplayPriority$Showside from "../hook/UseCategoryDisplayPriority.bs.js";
import * as LegacyShowside_CategoryDecoders$ApiTypes from "../../../../node_modules/api-types/lib/es6_global/src/LegacyShowside/LegacyShowside_CategoryDecoders.bs.js";
function getSlugCategory(url, topLevelCategories) {
  var regex = new RegExp("https:\/\/.+\/.+\/(ig|instagram|tiktok|tt|shop)", "i");
  var slug = Belt_Option.getWithDefault(Belt_Option.getWithDefault(Belt_Option.mapWithDefault(Caml_option.null_to_opt(url.match(regex)), undefined, function (__x) {
    return Belt_Array.get(__x, 1);
  }), undefined), "");
  var exit = 0;
  switch (slug) {
    case "ig":
    case "instagram":
      exit = 1;
      break;
    case "shop":
      var fn = function (cat) {
        return cat.title.toLowerCase() === "shop";
      };
      return Caml_option.undefined_to_opt(topLevelCategories.find(Curry.__1(fn)));
    case "tiktok":
    case "tt":
      exit = 2;
      break;
    default:
      return;
  }
  switch (exit) {
    case 1:
      return Caml_option.undefined_to_opt(topLevelCategories.find(function (cat) {
        var match = cat.socialNetworkSource;
        if (match !== undefined && match.TAG === /* Instagram */0) {
          return true;
        } else {
          return false;
        }
      }));
    case 2:
      return Caml_option.undefined_to_opt(topLevelCategories.find(function (cat) {
        var match = cat.socialNetworkSource;
        if (match !== undefined && match.TAG !== /* Instagram */0) {
          return true;
        } else {
          return false;
        }
      }));
  }
}
function MkrBioRouterProvider(Props) {
  var embedType = Props.embedType;
  var children = Props.children;
  var match = ConfigurationProvider$Showside.use(undefined);
  var config = match.config;
  var topLevelCategories = config.categories;
  var match$1 = RouterProvider$Showside.useRouter(undefined);
  var appliedFilters = match$1.productFilters;
  var appliedSort = match$1.productSort;
  var activeCategory = RouterProvider$Showside.useActiveCategory(undefined, undefined, topLevelCategories);
  var isForcingPLP = UseCategoryDisplayPriority$Showside.useCategoryDisplayPriority(activeCategory) === /* ProductsFirst */1;
  var isMkrBioEnabled = config.settings.mkrBio !== undefined;
  var url = window.location.href;
  if (!isMkrBioEnabled) {
    return children;
  }
  var slugCategory = getSlugCategory(url, topLevelCategories);
  var firstCategory = Belt_Option.getWithDefault(Belt_Array.get(Belt_Array.keep(topLevelCategories, function (category) {
    return category.visibleInMenuBar;
  }), 0), LegacyShowside_CategoryDecoders$ApiTypes.empty);
  var categoryId = slugCategory !== undefined ? slugCategory.id : firstCategory.id;
  var index = config.settings.indexNode;
  var initialRoute;
  var exit = 0;
  if (index !== undefined && index.visibleInMenuBar) {
    initialRoute = Belt_Option.map(slugCategory, function (category) {
      return {
        TAG: /* ListPage */1,
        _0: {
          listPageType: {
            TAG: /* Category */0,
            _0: category.id
          },
          viewPLP: isForcingPLP,
          filters: appliedFilters,
          sort: appliedSort
        }
      };
    });
  } else {
    exit = 1;
  }
  if (exit === 1) {
    initialRoute = {
      TAG: /* ListPage */1,
      _0: {
        listPageType: {
          TAG: /* Category */0,
          _0: categoryId
        },
        viewPLP: isForcingPLP,
        filters: appliedFilters,
        sort: appliedSort
      }
    };
  }
  var tmp = {
    configId: config.id,
    embedType: embedType,
    children: children
  };
  if (initialRoute !== undefined) {
    tmp.defaultInitialRoute = Caml_option.valFromOption(initialRoute);
  }
  return React.createElement(RouterProvider$Showside.make, tmp);
}
MkrBioRouterProvider.displayName = "MkrBioRouterProvider";
var make = MkrBioRouterProvider;
export { getSlugCategory, make };
/* react Not a pure module */